import React from 'react';
import './Quizik.css';
import QuizMain from './Newproject/QuizMain';

const Quizik = () => {
   
    return (
<div className='Quizik'>
       <QuizMain/>
</div>
    )
}

export default Quizik
